import store from '../ProjectForm/Store'
import { Form } from '@linqpal/models/src/mst/Form'
import { FullAddressModel } from '@linqpal/models/src/mst/ProjectForm'
import { getSnapshot } from 'mobx-state-tree'
import { PROJECT_SECTIONS } from '@linqpal/models/src/dictionaries'

export const mapToNewProjectModel = (address: string, contract: number) => {
  const data = {}
  Object.values(PROJECT_SECTIONS).forEach((sectionId) => {
    data[sectionId] = {
      group: sectionId,
      items: [...store.getQuestionsList(sectionId)],
    }
  })
  const form = Form.create({ data, currentSection: PROJECT_SECTIONS.ADDRESS })
  const adr = getSnapshot(FullAddressModel.create({ streetAddress: address }))
  form.setData(PROJECT_SECTIONS.ADDRESS, 'address', adr, false)
  form.setData(PROJECT_SECTIONS.INFORMATION, 'contractValue', contract, true)
  return getSnapshot(form.data)
}
